var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-success mx-2 ",on:{"click":_vm.btnClicked}},[_vm._v("جزییات سفارش")])])}
var staticRenderFns = []

export { render, staticRenderFns }